module.exports = __webpack_public_path__ + "img/archery.4e676a9.svg";